import {Typography,Box,Avatar} from '@mui/material';
import { ReactComponent as ReportChart } from "../../../assets/icons/icon-report-data.svg"
import React, {useEffect,useState} from 'react'
import getDataFromCube from '../../../utils/getCubeData';

import { SUBJECT_ICON } from '../../../constants/externalUrls'
import GenericIcon from '../../../assets/icons/Generic_Icon.svg'

function ListViewChart({resultSet,fieldsKeyInfo,columnDisplayName,columnTitle}) {
const [subjectIconData,setSubjectIconData] = useState([])


  const getSubjectIconData = async () => {
    const members = ["SubjectRackName.rackNameId", "SubjectRackName.subject"]
    try {
      const data = await getDataFromCube(undefined, undefined, undefined, "static_dashboard", members);
      if (data?.length) {
        setSubjectIconData(data)
      }
    }
    catch (error) {
      console.log("Error occured", error)
    }
  }

  useEffect(() => getSubjectIconData(), [])

  const mapSubjectIconData = (subject) => {
    if (subjectIconData.length) {
      const item = subjectIconData.find(ele => ele['SubjectRackName.subject'] === subject)
      if (item) {
        let url = SUBJECT_ICON.replace('{ID}', item['SubjectRackName.rackNameId'])
        return <Avatar src={url} style={{ backgroundColor: '#0000' }}>
          <img src={GenericIcon} alt="subject_icon" />
        </Avatar>
      }
      else {
        return <Avatar src={GenericIcon} />
      }
    }
  }

  const renderListViewChart = ({resultSet,fieldsKeyInfo}) => {
      let data1 = resultSet?.loadResponse?.results?.[0]?.data
      if (data1?.length) {

        return data1.map((item, i) => {

              if(item && Object.entries(item).length ) {
                let values = Object.entries(item)?.filter(e => ( e && e.length && e[1] !== undefined && e[1] !== null && e[1] !== '') )

                let rowData = [];
                for(let val=0; val<values.length;val++) {
                  let [k,v] = values[val];
                  console.log("k",k)
                  let kV =  columnTitle[0][k] || columnDisplayName[k] ||  k.split('.')[1] || k
                  let vV = v
                  if(val !== values.length -1) {
                    rowData.push(`${kV} : ${vV}`)
                  }
                  else {
                    rowData.push(`${kV} : ${vV}`)
                  }


                }
              return <li className="list-chart-li" >{rowData?.map((row => (<Typography>{row}</Typography>)))}</li>  
              }
              return null
             })
          }

              return (<Box className="width-100 text-center">
                <Box className='er-report-data-icon'><ReportChart /></Box>
                  <Typography className="er-report-data-info" variant='h4'>{'No Data Found'}</Typography>
                </Box>)
                          

}



  return (
      <ul className='er-keyareas-items' style={{margin:'8px'}}>
         {renderListViewChart({resultSet,fieldsKeyInfo})}
      </ul>
  )
}

export default ListViewChart
